import React from 'react';
import useRole from '../../components/GenericsHooks/useRoles';

export const withRoles = (WrappedComponent: any) => (props: any) => {
  let {
    promiseAdd,
    promiseDelete,
    promiseEdit,
    allowEdit,
    initialPermission,
    onlyEdit = false,
    allowActions = true,
    ...ignoredProps
  } = props;
  const role = useRole();
  let roleTrue = allowEdit;
  if (Array.isArray(allowEdit)) {
    roleTrue = allowEdit.find((x: any) => x === role);
  }

  if (role !== roleTrue) {
    promiseAdd = null;
    promiseDelete = null;
    if (!onlyEdit) {
      promiseEdit = null;
    }
  }

  if (props.noOneCanEdit === true) {
    promiseAdd = null;
    promiseEdit = null;
    promiseDelete = null;
  }
  if (onlyEdit) {
    const array: any[] = props.columnOptions;
    for (var i = 0; i < array.length; i++) {
      array[i].allowEdit = false;
    }
  }
  if (promiseAdd == null && promiseEdit == null && promiseDelete == null) {
    allowActions = false;
  }
  const wrapperProps = {
    promiseAdd,
    promiseEdit,
    promiseDelete,
    allowActions,
    ...ignoredProps,
  };
  return <WrappedComponent {...wrapperProps} />;
};
